const infraErrorPattern =
  /\b(auth0|bucket|constraint|database|db|endpoint|er_[a-z0-9_]+|mysql|s3|sql|typeorm)\b/i

export function dashboardApiErrorMessage(error: unknown, fallback: string) {
  const message = error instanceof Error ? error.message.trim() : ""
  if (!message) return fallback
  if (infraErrorPattern.test(message)) return fallback
  return /^Could not [a-z][\w\s-]+\.$/.test(message) ? message : fallback
}
